import { render } from "./AccGZ.vue?vue&type=template&id=0c8867ee"
import script from "./AccGZ.vue?vue&type=script&lang=js"
export * from "./AccGZ.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__